"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarWaterPumpingOnGridConstants = void 0;
class SolarWaterPumpingOnGridConstants {
    constructor() {
        this.emissionFactor = 1.06;
        this.emissionFactorUnit = "kWh/year";
    }
}
exports.SolarWaterPumpingOnGridConstants = SolarWaterPumpingOnGridConstants;
